<template>
  <div id="footer-wrapper">
    <div id="footer">
      <div class="container">
        <div class="row">
          <div class="span3">
            <h3>网站主要功能</h3>
            <ul>
              <li>青蓝校园 · 校园信息发布与交流平台</li>
              <li>提供校园问答、二手交易、活动报名、招聘信息等服务</li>
              <li>公告：禁止发布不当言论，违规账号将被封禁处理</li>
            </ul>
          </div>
          <div class="span3">
            <h3>友情链接</h3>
            <ul>
              <li><a href="javascript:;">青蓝大学官网</a></li>
              <li><a href="javascript:;">青蓝大学教务处</a></li>
              <li><a href="javascript:;">图书馆</a></li>
              <li><a href="javascript:;">校团委</a></li>
            </ul>
          </div>
          <div class="span3">
            <h3>广告信息</h3>
            <ul>
              <li>诚邀校园商家入驻平台</li>
              <li>联系邮箱：ad@qinglan.edu.cn</li>
            </ul>
          </div>
          <div class="span3">
            <h3>客服中心</h3>
            <ul>
              <li><router-link to="/fankui">意见反馈</router-link></li>
              <li><router-link to="/shensu">账号解封</router-link></li>
              <li><router-link to="/jubao">不良行为举报</router-link></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div id="footer-bottom">
      Copyright © 2026 - 青蓝校园 · 校园信息交流平台
    </div>
  </div>
</template>

<script>
export default {
  name: 'Foot'
}
</script>
